module.exports = __webpack_public_path__ + "static/media/spaceBubble.32953b04.png";